module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inside"
  }, [(false) ? _c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inside-in",
    attrs: {
      "id": "page"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ab6d828"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inside.vue
// module id = 350
// module chunks = 0